var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "39px",
    viewBox: "0 0 54 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8282\u70B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.5489271%",
    y1: "23.9197531%",
    x2: "40.7563079%",
    y2: "40.9976106%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2B3E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875-\\u6B63\\u5F0F",
    transform: "translate(-116.000000, -293.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-43",
    transform: "translate(26.000000, 293.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8282\\u70B9",
    transform: "translate(90.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-23",
    stroke: "url(#linearGradient-2)",
    strokeWidth: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3477493,0.275 L31.7764552,0.275 L53.6381348,30.7144808 L45.3639798,38.725 L4.76670584,38.725 L0.325512028,30.7658979 L22.3477493,0.275 Z",
    id: "\\u8DEF\\u5F84-10",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3477493,0.275 L31.7764552,0.275 L53.6381348,30.7144808 L45.3639798,38.725 L4.76670584,38.725 L0.325512028,30.7658979 L22.3477493,0.275 Z",
    id: "\\u8DEF\\u5F84-10",
    transform: "translate(27.000000, 19.500000) scale(1, -1) translate(-27.000000, -19.500000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8282\\u70B9\\u7BA1\\u7406",
    transform: "translate(16.530612, 8.914286)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    x: 0,
    y: 0,
    width: 20.9387755,
    height: 21.1714286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54336735,10.5857143 C6.54336735,12.7780875 8.30110656,14.5553571 10.4693878,14.5553571 C12.637669,14.5553571 14.3954082,12.7780875 14.3954082,10.5857143 C14.3954082,8.39334107 12.637669,6.61607143 10.4693878,6.61607143 C8.30110656,6.61607143 6.54336735,8.39334107 6.54336735,10.5857143 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.630102,10.5857143 C19.630102,9.47752232 19.437727,8.39579464 19.0654094,7.37691964 C18.9352159,7.04186497 18.5639721,6.87354909 18.2299413,6.99813206 C17.8959105,7.12271502 17.7216936,7.49447057 17.8378737,7.83475179 C18.1565357,8.70807321 18.3214286,9.63498482 18.3214286,10.5857143 C18.3214286,11.0415616 18.2749707,11.4861616 18.2016849,11.9208375 C17.5296746,11.9813897 17.0141522,12.5499745 17.0127551,13.2321429 C17.0127551,13.6224911 17.1828827,13.9698348 17.4491977,14.211983 C16.1457589,16.7710795 13.5127079,18.525 10.4693878,18.525 C6.13309821,18.525 2.61734694,14.9701848 2.61734694,10.5857143 C2.61734694,10.129867 2.66380485,9.68526696 2.73709056,9.25059107 C3.40910088,9.19003884 3.92462334,8.6214541 3.92602041,7.93928571 C3.92602041,7.5489375 3.75589286,7.20159375 3.48957781,6.95944554 C4.79301658,4.40034911 7.4260676,2.64642857 10.4693878,2.64642857 C11.1505523,2.64642857 11.8153584,2.74434643 12.4592258,2.91437946 C12.5998833,3.57431896 13.208917,4.02170385 13.8731222,3.95300165 C14.5373274,3.88429944 15.0441558,3.32149511 15.0497449,2.64642857 C15.0497449,1.9156375 14.4638318,1.32321429 13.7410714,1.32321429 C13.4086684,1.32321429 13.1083278,1.45288929 12.8773469,1.65931071 C12.0929808,1.43983085 11.2832281,1.32680776 10.4693878,1.32321429 C6.78285459,1.32321429 3.61390179,3.52967411 2.1606199,6.70340357 C1.64930285,6.89512244 1.30962038,7.38788522 1.30867347,7.93928571 C1.30867347,8.19929732 1.38523087,8.44012232 1.51348087,8.64455893 C1.3779791,9.28254262 1.30933108,9.93318555 1.30867347,10.5857143 C1.30867347,15.7012607 5.41005612,19.8482143 10.4693878,19.8482143 C14.1559209,19.8482143 17.3248737,17.6417545 18.7781556,14.468025 C19.2894727,14.2763061 19.6291551,13.7835433 19.630102,13.2321429 C19.630102,12.9721312 19.5535446,12.7313062 19.4252946,12.5268696 C19.5574707,11.9003277 19.630102,11.2519527 19.630102,10.5857143 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "#FFFFFF",
    strokeWidth: 0.77,
    strokeDasharray: 0.7699999868869782
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.6e733d86e87c8816d7abe8c6909a1113.svg";
export { ForwardRef as ReactComponent };